<template>
	<div class="data-ingredient">
		<div class="page-header">食材</div>
		<ingredient-search @handleAdd="handleAdd" @changeDataMode="changeDataMode" @search="search"></ingredient-search>
		<el-row :gutter="15" style="padding:15px" v-if="dataModel">
			<el-col style="width:210px;height:180px;margin-bottom:12px"  v-for="item in ingredientList" :key="item.id">
				<di-card shadow="hover" :data="item" :body-style="{ 'padding': '0px' }" :view-style="{'height': '150px','lineHeight': '150px'}"
					@view="view"
					@edit="edit"
					@link="link">
      		 		<img v-if="item.ingredientsImageUrl" :src="item.ingredientsImageUrl+'?x-oss-process=image/resize,m_fill,h_150,w_200'" class="image">
					<el-image v-else
						style="width: 200px; height: 150px;"
						:src="item.ingredientsImageUrl"
						fit="cover">
						<div slot="error" class="image-slot" style="height:150px;">
        					<div class="el-image__error">暂无图片</div>
      					</div>
						</el-image>
					 <div style="padding: 5px;">
						<span>{{item.commonName}}</span>
					 </div>
    			</di-card>
			</el-col>
		</el-row>
		<div style="padding:15px 0 15px 15px" v-else>
      <el-table ref="dishesTable"
                :data="ingredientList"
                style="width: 100%;"
                v-loading="listLoading">
        <el-table-column label="菜名"  align="left">
					<template slot-scope="scope">
						 <el-button size="mini"
                       type="text"
                       @click="view(scope.row)">
              {{scope.row.commonName}}
            </el-button>
					</template>
        </el-table-column>
				<el-table-column label="编号" prop="ingredientsCode" align="center">
        </el-table-column>
        <el-table-column label="大类" prop="bigCateName" align="center">
        </el-table-column>
				<el-table-column label="小类" prop="smallCateName" align="center">
        </el-table-column>
        <el-table-column label="别名" align="left" prop="aliasName">
        </el-table-column>
				<el-table-column label="常用名" align="center" prop="commonName">
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="text"
                       @click="edit(scope.row)">
              编辑基本信息
            </el-button>
            <el-button size="mini"
                       type="text"
                       @click="link(scope.row)">编辑适用信息
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
		<div style="display: inline-block;float: right;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="ingredientListQuery.pageNumber"
        :page-size="ingredientListQuery.pageSize"
        :page-sizes="[10,15,20]"
        :total="total">
      </el-pagination>
    </div>
		<el-drawer
			title="我是标题"
			:visible.sync="drawer"
			:with-header="false"
			size="290px">
			<div style="padding:15px">
				<el-card :body-style="{ padding: '0px' }" shadow="never">
				<img v-if="ingredientModel.ingredientsImageUrl" :src="ingredientModel.ingredientsImageUrl+'?x-oss-process=image/resize,m_fill,h_210,w_280'" class="image">
				<el-image v-else
					style="width: 280px; height: 210px;"
					fit="cover">
					<div slot="error" class="image-slot" style="height:210px;">
								<div class="el-image__error">暂无图片</div>
							</div>
				</el-image>
				</el-card>
			</div>
			<div style="padding:0 15px 0 15px;text-align:left;">
				<span style="font-size: 16px;font-weight: bold;display: inline-block;margin-right: 20px;">{{ingredientModel.commonName}}</span>
				<span class="child-content">{{ingredientModel.ingredientsCode}}</span>
				<span>{{ingredientModel.commonlyUsedFlag==1?'常用':'不常用'}}/{{ingredientModel.halalFlag==1?'清真':'非清真'}}</span>
			</div>
			<div style="padding:15px">
				<table style="width: 100%;">
					<tr>
						<td class="detail-title">别   名：</td><td class="detail-title__t">{{ingredientModel.aliasName}}</td>
						<td class="detail-title">大   类：</td><td class="detail-title__t">{{ingredientModel.bigCateName}}</td>
					</tr>
					<tr>
						<td class="detail-title">常用名：</td><td class="detail-title__t">{{ingredientModel.commonName}}</td>
						<td class="detail-title">小  类：</td><td class="detail-title__t">{{ingredientModel.smallCateName}}</td>
					</tr>
					<tr>
						<td class="detail-title">功效作用：</td><td class="detail-title__t" colspan="3">{{ingredientModel.efficacy | filterDicts}}</td>
					</tr>
					<tr>
						<td class="detail-title">适宜搭配：</td><td class="detail-title__t" colspan="3">{{ingredientModel.suitable | filterSuitable}}</td>
					</tr>
				</table>
			</div>
			<div style="padding: 0 15px 15px 15px;">
				<el-tabs v-model="activeName"  @tab-click="handleClick">
					<el-tab-pane label="营养素" name="first">
							<el-table ref="adminTable"
                :data="nutrientList"
                style="width: 100%;"
                v-loading="listLoading"
								:show-header="false">
							<el-table-column label="名称" prop="name" align="left">
							</el-table-column>
							<el-table-column label="shu" prop="weight" align="left">
							</el-table-column>
							<el-table-column label="unit" prop="unit" align="left">
							</el-table-column>
							</el-table>
							<el-divider></el-divider>
							<el-button type="text" @click="loadAllNutri" v-if="isall">全部</el-button>
					</el-tab-pane>
					<el-tab-pane label="适用信息" name="second">
						<el-row style="text-align:left">
							<span class="child-content" style="margin-right:30px">适用人群</span>
							<span class="child-content">
								{{ingredientModel.crowd | filterDicts}}
							</span>
						</el-row>
						<el-divider></el-divider>
						<el-row style="text-align:left">
							<el-col :span="6">季节常用性</el-col>
							<el-col :span="12">
								<span v-for="(item,index) in ingredientModel.season" :key="index" style="display:inline-block;margin-bottom:6px">
									<span class="child-content">
										{{item.itemDictValue | filterSeason}}
									</span>
									<span class="child-content" style="text-align:right;width: 30px;display: inline-block;">{{item.itemDictName}}</span>
									<span class="child-content" style="text-align:right;width: 60px;display: inline-block;">{{item.valueDictName}}</span>
								</span>
							</el-col>
						</el-row>
						<el-divider></el-divider>
						<el-row style="text-align:left">
							<el-col :span="7">地域常用性</el-col>
							<el-col :span="15">
								<el-row  v-for="(val,key) in ingredientModel.area" :key="key" style="margin-bottom:6px">
									<el-col :span="5">
										{{key}}
									</el-col>
									<el-col :span="19">
										<span v-for="(item, index) in val" :key="index" style="display:block;margin-bottom:6px">
											<span class="child-content" style="text-align:left;width: 96px;display: inline-block;">{{item.areaName}}</span>
											<span class="child-content" style="text-align:left;width: 45px;display: inline-block;">{{item.valueDictName != null?item.valueDictName:'不常用'}}</span>
										</span>
									</el-col>
								</el-row>
							</el-col>
						</el-row>
					</el-tab-pane>
					<el-tab-pane label="相关信息" name="third">
						<div style="text-align:left;margin-bottom: 12px">相近食材</div>
						<el-row>
							<el-col style="width:130px;height:95px;margin-bottom:45px;margin-right: 9px;" v-for="item in ingredientModel.notSuitable" :key="item.id">
								<el-card shadow="never" :body-style="{ padding: '0px' }">
									<img v-if="item.relateImageUrl"  :src="item.relateImageUrl+'?x-oss-process=image/resize,m_fill,h_90,w_120'" class="image">
									<el-image v-else
										style="width: 120px; height: 90px;"
										:src="item.relateImageUrl"
										fit="cover">
										<div slot="error" class="image-slot" style="height:90px;">
													<div class="el-image__error">暂无图片</div>
												</div>
										</el-image>
									<div style="padding: 5px;">
										<span>{{item.relateName}}</span>
									</div>
								</el-card>
							</el-col>
						</el-row>
						<el-divider></el-divider>
						<el-row style="text-align:left;">
							<el-col :span="5">
								不宜同食
							</el-col>
							<el-col :span="18">
								<div style="margin-bottom: 10px;" v-for="(item, index) in ingredientModel.notSuitable" :key="index">
									<div style="margin-bottom: 5px;">{{item.relateName}}</div>
									<div>{{item.remark}}</div>
								</div>
							</el-col>
						</el-row>
						<el-divider></el-divider>
						<div style="text-align: left;margin-bottom: 12px;height: 20px;line-height: 20px;">
							<div style="float: left;">相关菜品</div>
							<div style="float: right;">
								<el-button type="text" @click="queryLikeDishes(ingredientModel.id)" style="color:#101010">换一批</el-button>
							</div>
						</div>
						<el-row>
							<el-col style="width:120px;height:95px;margin-bottom:45px;margin-right: 9px;" v-for="item in likeDishesList" :key="item.id">
								<el-card shadow="never" :body-style="{ padding: '0px' }">
									<img v-if="item.dishesImageUrl"  :src="item.dishesImageUrl+'?x-oss-process=image/resize,m_fill,h_90,w_120'" class="image">
									<el-image v-else
										style="width: 120px; height: 90px;"
										fit="cover">
										<div slot="error" class="image-slot" style="height:90px;">
													<div class="el-image__error">暂无图片</div>
												</div>
										</el-image>
									<div style="padding: 5px;">
										<span>{{item.dishesName}}</span>
									</div>
								</el-card>
							</el-col>
						</el-row>
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import IngredientSearch from './ingredient_search.vue'
import DiCard from '@/views/datacenter/components/basedata/dicard.vue'
import {fetchIngredientList,queryIngredientDetail,loadByIngredientsId} from '@/api/catering/ingredient'
const defaultListQuery = {
	pageNumber: 1,
	pageSize: 20
};
const defaultLikeDishesQuery = {
	ingredientsId: null,
	pageNumber: 1,
	pageSize: 6
};
export default {
	name: "KidIngredient",
	components:{
		IngredientSearch,
		DiCard
	},
  data() {
    return {
			dataModel: true,
			isall: true,
			ingredientListQuery: Object.assign({}, defaultListQuery),
			ingredientList: [],
			total: null,
			activeName: "first",
			isShow: false,
			drawer: false,
			fullscreenLoading: true,
			listLoading: false,
			nutrientList:[],
			tmpNutrientList:[],
			ingredientModel: {
				ingSrc: 'https://kiddishes.oss-cn-hangzhou.aliyuncs.com/baicai.jpg?x-oss-process=image/resize,m_fill,h_210,w_280'
			},
			likeDishesList: [],
			likeDishesCount: 0,
			likeDishesQuery: Object.assign({},defaultLikeDishesQuery),
    };
  },
	filters: {
		filterDicts(dictArray) {
			if(dictArray) {
				let str = "";
				dictArray.map(item=>{
					str += item.itemDictName+ " ";
				})
				return str;
			}
		},
		filterSuitable(val) {
			if(val) {
				let str = "";
				val.map(item=>{
					str += item.relateName+ " ";
				})
				return str;
			}
		},
		filterSeason(val) {
			if(val == 1 || val == 2 || val == 12) {
				return '冬季';
			}
			if(val == 3 || val == 4 || val == 5) {
				return '春季';
			}
			if(val == 6 || val == 7 || val == 8) {
				return '夏季';
			}
			if(val == 9 || val == 10 || val == 11) {
				return '秋季';
			}
		}
	},
	created() {
		if(this.$route.params.page) {
			this.ingredientListQuery.pageNumber = this.$route.params.page;
		}
		this.loadIngreditentList(this.ingredientListQuery);
	},
  methods: {
    search(query) {
			this.ingredientListQuery = Object.assign(query,defaultListQuery);
			this.loadIngreditentList(this.ingredientListQuery);
		},
		loadIngreditentList(params) {
			this.listLoading = true;
			fetchIngredientList(params).then(response=>{
				this.ingredientList = response.data.records;
				this.total = response.data.total;
				this.listLoading = false;
			})
		},
		handleSizeChange(val) {
        this.ingredientListQuery.pageNumber = 1;
        this.ingredientListQuery.pageSize = val;
        this.loadIngreditentList(this.ingredientListQuery);
      },
    handleCurrentChange(val) {
        this.ingredientListQuery.pageNumber = val;
        this.loadIngreditentList(this.ingredientListQuery);
    },
		changeDataMode(val) {
			this.dataModel = val;
		},
		view(data) {
			this.fullscreenLoading = true;
			this.isall = true;
			this.nutrientList = [];
			this.tmpNutrientList = [];
			this.likeDishesList = [];
			this.likeDishesQuery = Object.assign({},defaultLikeDishesQuery);
			queryIngredientDetail(data.id).then(response=>{
				let data = response.data;
				this.ingredientModel = data;
				this.nutrientListStruct(data);
				this.queryByIngredientsId(data.id);
				this.listLoading = false;
			});
			this.drawer = true;
		},
		queryLikeDishes(id){
			this.likeDishesQuery.pageNumber = this.likeDishesQuery.pageNumber+1;
			if(this.likeDishesCount <= this.likeDishesQuery.pageNumber*this.likeDishesQuery.pageSize) {
				this.likeDishesQuery.pageNumber = 1;
			}
			this.queryByIngredientsId(id);
		},
		queryByIngredientsId(id) {
			this.likeDishesQuery.ingredientsId = id;
			loadByIngredientsId(this.likeDishesQuery).then(response=>{
				this.likeDishesList = response.data.records;
				this.likeDishesCount = response.data.total;
			})
		},
		edit(data) {
			this.$router.push({'path':'/datacenter/ingredientedit/dataingredientedit',query:{uid:data.id,page:this.ingredientListQuery.pageNumber}})
		},
		link(data) {
			this.$router.push({'path':'/datacenter/ingredientapplyinfo/dataingredientapply',query:{uid:data.id,page:this.ingredientListQuery.pageNumber}})
		},
		handleAdd() {
			this.$router.push({'path':'/datacenter/ingredientedit/dataingredientedit'})
		},
		handleClick(tab) {
			if(tab.name == 'second') {
				let d = [{title:'季节常用行',name:'冬季',month:'1月',times: '每天一次'}];
			}
		},
		loadAllNutri() {
			this.nutrientList = this.nutrientList.concat(this.tmpNutrientList);
			this.isall = false;
		},
		nutrientListStruct(data) {
			this.nutrientList.push({name: '可食部', weight: data.eatPart,unit: ''});
			this.nutrientList.push({name: '热量', weight: data.energyKc,unit: '千卡'});
			this.nutrientList.push({name: '碳水化合物', weight: data.carbohydrate,unit: '克'});
			this.nutrientList.push({name: '蛋白质', weight: data.protein,unit: '克'});
			this.nutrientList.push({name: '脂肪', weight: data.fat,unit: '克'});
			this.nutrientList.push({name: '钙', weight: data.autunite,unit: '毫克'});
			this.nutrientList.push({name: '锌', weight: data.zicn,unit: '毫克'});
			this.nutrientList.push({name: '铁', weight: data.iron,unit: '毫克'});
			this.nutrientList.push({name: '维生素A', weight: data.va,unit: '毫克'});
			this.nutrientList.push({name: '维生素B1', weight: data.vb1,unit: '毫克'});
			this.nutrientList.push({name: '维生素B2', weight: data.vb2,unit: '毫克'});
			this.nutrientList.push({name: '维生素C', weight: data.vc,unit: '毫克'});

			this.tmpNutrientList.push({name: '膳食纤维', weight: data.df,unit: '克'})
			this.tmpNutrientList.push({name: '能量', weight: data.energyKj,unit: '千焦'});
			this.tmpNutrientList.push({name: '水分', weight: data.moisture,unit: '克'});
			this.tmpNutrientList.push({name: '胆固醇', weight: data.cholesterol,unit: '毫克'});
			this.tmpNutrientList.push({name: '灰分', weight: data.ashContent,unit: '克'});
			this.tmpNutrientList.push({name: '胡萝卜素', weight: data.carotene,unit: '微克'});
			this.tmpNutrientList.push({name: '视黄醇', weight: data.retinol,unit: '微克'});
			this.tmpNutrientList.push({name: '烟酸', weight: data.vpp,unit: '微克'});
			this.tmpNutrientList.push({name: '维生素E', weight: data.ve,unit: '微克'});
			this.tmpNutrientList.push({name: '磷', weight: data.phosphorus,unit: '微克'});
			this.tmpNutrientList.push({name: '钾', weight: data.kalium,unit: '微克'});
			this.tmpNutrientList.push({name: '钠', weight: data.na,unit: '微克'});
			this.tmpNutrientList.push({name: '镁', weight: data.magnesium,unit: '微克'});
			this.tmpNutrientList.push({name: '硒', weight: data.selenium,unit: '微克'});
			this.tmpNutrientList.push({name: '铜', weight: data.copper,unit: '微克'});
			this.tmpNutrientList.push({name: '锰', weight: data.mineral,unit: '微克'});
		}
  }
};
</script>
<style lang="scss" scoped>
.detail-title	{
		white-space: pre-wrap;
		height: 25px;
		text-align: left;
}
.detail-title__t {
	text-align: left;
}
.detail-title__o {
	text-align: left;
}
.child-content {
	// display: inline-block;
	margin-right: 15px;
}
</style>





// WEBPACK FOOTER //
// src/views/datacenter/components/basedata/ingredient/index.vue